import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from '../services/base.service';
import { CourseService } from '../services/course.service';

@Injectable({
    providedIn: 'root'
})

export class CourseResolver implements Resolve<ApiObjectData> {
    constructor(
        private service: CourseService,
        private baseService: BaseService
    ) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ApiObjectData> {
        return this.baseService.resolveGet(this.service, route, '/page/Course');
    }
}

@Injectable({
    providedIn: 'root'
})

export class CoursesResolver implements Resolve<ApiObjectData> {
    constructor(
        private service: CourseService,
        private baseService: BaseService
    ) { }
    resolve(): Observable<ApiObjectData> {
        return this.baseService.resolveGets(this.service);
    }
}